/* eslint-disable react-hooks/exhaustive-deps */
import React from 'react'
import { PopupLayer } from '../../components'

const TestingPopupLayer = () => {

  return (
    <PopupLayer />
  )
}

export default React.memo(TestingPopupLayer)
